import React from "react";
import { FormControl, FormHelperText, styled } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

const CustomDatePicker = styled(DatePicker)(({ theme }) => ({
  "& .MuiInputBase-input": {
    fontSize: 14,
  },
  "& .MuiOutlinedInput-root": {
    border: "none",
    fontSize: "14px",
    backgroundColor: "transparent",
    fontFamily: "Inter Tight",
    padding: "8px",
    "&.Mui-focused": {
      outline: "none",
    },
    "& .MuiAutocomplete-input": {
      padding: 0,
    },
    "& .MuiAutocomplete-root": {
      backgroundColor: "#fff",
    },
  },
}));

const FieldsetWrapper = styled("fieldset")(({ theme, error }) => ({
  borderRadius: "12px",
  padding: "8px 12px",
  border: error ? "1px solid red" : "1px solid rgba(18, 18, 21, 0.10)",
  backgroundColor: "#fff",
  fontFamily: "Inter Tight",
  transition: "border-color 0.3s ease",
  "&:focus-within": {
    borderColor: theme.palette.primary.main,
  },
}));

const Legend = styled("legend")(({ error }) => ({
  fontSize: "13px",
  fontWeight: "500",
  padding: "0 5px",
  color: error ? "red" : "#0D0D0E",
}));

const CDatePicker = ({
  value,
  onChange,
  error,
  helperText,
  label,
  isProjectUpdate,
  allowPastDates = false,
  ...props
}) => {
  return (
    <FormControl fullWidth error={error} variant="standard">
      <FieldsetWrapper error={error}>
        {label && <Legend error={error}>{label}</Legend>}
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <CustomDatePicker
            value={value}
            onChange={onChange}
            format="MMMM dd, yyyy"
            disablePast={allowPastDates ? false : !isProjectUpdate}
            maxDate={isProjectUpdate ? new Date() : undefined}
            slotProps={{
              textField: {
                variant: "standard",
                InputProps: { disableUnderline: true },
              },
              popper: {
                placement: 'bottom-start',
                disablePortal: false,
                modifiers: [
                  {
                    name: 'preventOverflow',
                    enabled: true,
                    options: {
                      altBoundary: true,
                      rootBoundary: 'viewport',
                      padding: 8,
                    },
                  },
                  {
                    name: 'flip',
                    enabled: true,
                    options: {
                      altBoundary: true,
                      rootBoundary: 'viewport',
                      padding: 8,
                    },
                  },
                ],
                sx: {
                  zIndex: 1400,
                  '& .MuiPaper-root': {
                    maxWidth: '100%',
                  },
                },
              },
            }}
            sx={{ width: "100%" }}
            {...props}
          />
        </LocalizationProvider>
      </FieldsetWrapper>

      <FormHelperText error={error} style={{ fontFamily: "Inter Tight" }}>
        {helperText}
      </FormHelperText>
    </FormControl>
  );
};

export default CDatePicker;
